import { ShareIcon } from "@heroicons/react/24/outline"
import { Outlet } from "react-router"
import IconButton from "../components/common/icon-button"
import { useEffect } from "react"
const ViewerLayout = () => {
    return <div className="w-full h-full">
        <Outlet />
    </div>
}


export default ViewerLayout;